import React, { useState } from 'react';
import { RiCloseLargeLine } from 'react-icons/ri';
import { GiHamburgerMenu } from 'react-icons/gi';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Notifications } from './Notifications';
import { getIconSrc } from '../helpers/getImgSrc';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '40px',  // minimum height of the control
    height: '40px',  // fixed height
    fontSize: '14px',  // adjust font size if needed
    fontFamily: 'aeonik_medium',  // customize font family
    border: state.isFocused ? '1px solid #007bff' : '1px solid #ced4da',  // border style
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : null,
    borderRadius: '8px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '40px',
    width: '110px',
    padding: '0 8px',  // adjust padding to align text
    display: 'flex',
    alignItems: 'center',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0',
    padding: '0',
    height: '40px',
  }),
  singleValue: (provided) => ({
    ...provided,
    lineHeight: '40px',
    fontFamily: 'aeonik_bold',
    fontSize: '14px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '40px',
  }),
  indicatorSeparator: () => ({
    display: 'none',  // remove the default indicator separator
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '4px',
    color: '#7F56D9',
  }),
};

const NavMobileMenu = ({ handleClientSelectChange,handleProgramSelectChange, clientList,programList}) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const user = useSelector((state) => state?.user);

  return (
    <div className="d-flex align-items-center d-block d-xl-none">
      {/* Hamburger Icon to toggle menu */}
     
      <i className='bi bi-justify-right fs-2' onClick={() => setShowMobileMenu((prev) => !prev)}/>


      {/* Mobile Menu */}
      {showMobileMenu && (
        <div className="mobile_menu d-flex flex-column gap_md">
          <div className='d-flex justify-content-between align-items-center'>
            {/* Close Button */}
          <i className='bi bi-x-lg fs-2 m-0' onClick={() => setShowMobileMenu(false)}/>

          <Notifications />
          </div>


            {/* Profile Section */}
            <div className="d-flex flex-column align-items-center gap-2">
              {user?.profile_image ? (
                <img src={user?.profile_image} className="img-fluid rounded-circle " alt="Profile" 
                style={{ width: '60px', height: '60px', borderRadius: '50%' }}

                />
              ) : (
                <div
                  style={{ width: '60px', height: '60px', borderRadius: '50%' }}
                  className="d-flex justify-content-center align-items-center bg-primary text-white"
                >
                  <p className="mb-0">{user?.first_name[0]?.toUpperCase()}{user?.last_name[0]?.toUpperCase()}</p>
                </div>
              )}
              <p className="mb-0 text-center">Hello, {user?.first_name}</p>
            </div>

            {/* Organisation and Program Select */}
            {!user?.is_super_admin && (
              <div className="d-flex flex-column gap_md" >
                <p className="mb-0">Check out your source for</p>

                {/* Organisation Select */}
                <div className="d-flex flex-column  bg-white gap-2 rounded position-relative" >
                  <label className="mb-0">Organisation:</label>
                  <div className="custom-select-container" >
                    <Select
                      onChange={handleClientSelectChange}
                      value={{ value: user?.client_id, label: user?.client_name }}
                      styles={customStyles}
                      isSearchable={true}
                      options={clientList.map((client) => ({
                        value: client?.client_id,
                        label: client?.client_name,
                      }))}
                    />
                  </div>
                </div>

                {/* Programs Select */}
                <div className="d-flex flex-column bg-white gap-2 rounded">
                  <label className="mb-0">Programs:</label>
                  <div className="custom-select-container nav_select">
                    <Select
                      onChange={handleProgramSelectChange}
                      value={{
                        value: user?.program_id || null,
                        label: user?.program_name || 'All',
                      }}
                      styles={customStyles}
                      options={[
                        { value: null, label: 'All' },
                        ...programList.map((program) => ({
                          value: program?.program_id,
                          label: program?.program_name,
                        })),
                      ]}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Sync Button */}
            <button className="btn btn-primary rounded-pill px-3  w-100">
              <i className="bi bi-arrow-repeat"></i> Sync
            </button>

            {/* Export Stats Button (only visible if not super admin) */}
            {!user?.is_super_admin && (
              <button className="btn rounded-pill btn-primary gap-1 d-flex align-items-center justify-content-center w-100">
                 <img className="" src={getIconSrc("export","svg")} /> Export Stats
              </button>
            )}
          </div>
      )}
    </div>
  );
};

export default NavMobileMenu;
